// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"a923eabd","136":"13422649","181":"3e113cde","299":"70c48ac7","369":"df267076","457":"291ffbf8","823":"72464332","859":"e41090f7","949":"3153c89f"}[chunkId] + ".chunk.js";
};